/* ============================================================================
 * ⚠️  ATENCAO — NAO COLOQUE CHAVE DE API NESTE ARQUIVO
 * ============================================================================
 *
 * Este componente chamava Dify, ElevenLabs e Groq DIRETO DO NAVEGADOR, usando
 * REACT_APP_*. Tudo que e REACT_APP_* vai para dentro do pacote publico: basta
 * abrir o site e ler o arquivo .js para ver a chave.
 *
 * As chaves que estavam aqui foram REVOGADAS em 24/08/2026.
 *
 * Situacao hoje (medida em 24/08/2026):
 *   - a rota /dashboard/robo esta comentada no router
 *   - MAS a tela Downloads renderiza <ChatApp /> (linha 49), entao este
 *     componente ESTA no pacote publicado de smidiomas_front e asking-frontend-web
 *   - as variaveis nao estavam definidas quando esses pacotes foram compilados,
 *     por isso NENHUMA chave vazou ate agora
 *
 * 🚨 O PERIGO: basta alguem por chaves validas no .env e recompilar. Elas vao
 *    para o pacote publico automaticamente, sem aviso nenhum.
 *
 * SE FOR REATIVAR ESTA TELA: faca as chamadas passarem pelo SERVIDOR, como ja
 * foi feito no TiqChat (POST /chat e POST /transcrever). A chave fica no
 * servidor e nunca chega ao navegador.
 * ============================================================================ */

import React, { useState, useEffect, useRef } from 'react';
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder'; // Importa o gravador de áudio
import axios from 'axios';
import gifAnimado1 from 'assets/animations/mobile_falando_v3.gif';
import gifAnimado2 from 'assets/animations/mobile_falando_v3.gif';
import gifAnimado3 from 'assets/animations/mobile_falando_v3.gif';
import gifAnimado from 'assets/animations/mobile_falando_v3.gif';
/*import gifAnimado1 from '../assets/animations/Bruninho_falando.gif';
import gifAnimado2 from '../assets/animations/Bruninho_falando.gif';
import gifAnimado3 from '../assets/animations/Bruninho_falando.gif';
import gifAnimado from '../assets/animations/Bruninho_falando.gif';*/
import acabou from 'assets/audio/creditos_acabaram_v2.mp3';
import 'styles/ChatApp.css';
import recordingImage from 'assets/images/bt_circular.png';
import stopImage from 'assets/animations/bt_circular_pausar.gif';

const MAX_RESPONSES = 21;

const ChatApp = () => {
  const [record, setRecord] = useState(false);
  const [response, setResponse] = useState('');
  const [audioUrl, setAudioUrl] = useState(null);
  const [audioText, setAudioText] = useState('');
  const [conversationId, setConversationId] = useState('');
  const [isPlaying, setIsPlaying] = useState(false);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [responseCount, setResponseCount] = useState(0);
  const [showLimitGif, setShowLimitGif] = useState(false);
  const [gifIndex, setGifIndex] = useState(0);
  const audioRef = useRef(null);

  //const [startTime, setStartTime] = useState(null); // Tempo de início do áudio
  //const [endTime, setEndTime] = useState(null); // Tempo de término do áudio

  const gifs = [gifAnimado1, gifAnimado2, gifAnimado3];
//inseri o bloco abaixo para tentar resolver problema do audio em iOS
  const handleAudioReady = () => {
    audioRef.current.play().catch(error => {
      console.error('Erro ao tentar reproduzir o áudio:', error);
    });
  };

  const recorderControls = useAudioRecorder(
    {
      noiseSuppression: true,
      echoCancellation: true,
      samplerate: 8000,
    },
    (err) => console.table(err) // onNotAllowedOrFound
  );

  const handleRecordingComplete = async (blob) => {
    console.log('=== INÍCIO DO PROCESSO ===');
    console.log('1. Áudio gravado com sucesso:', blob);
    console.log('Tamanho do áudio:', blob.size, 'bytes');
    console.log('Tipo do áudio:', blob.type);
    
    setLoading(true);
    setProgress(0);

    const formData = new FormData();
    formData.append('file', blob, 'audio.m4a');
    formData.append('model', 'whisper-large-v3');
    formData.append('temperature', 0);
    formData.append('response_format', 'json');
    formData.append('language', 'pt');

    const updateProgress = () => {
      setProgress((prev) => (prev < 90 ? prev + 10 : prev));
    };

    const interval = setInterval(updateProgress, 500);

    try {
      console.log('2. Iniciando transcrição com Groq...');
      console.time('Audio to Text API');
      const audioToTextResponse = await axios.post('https://api.groq.com/openai/v1/audio/transcriptions', formData, {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_GROQ_API_KEY}`,
          'Content-Type': 'multipart/form-data'
        },
      });
      console.timeEnd('Audio to Text API');

      const transcribedText = audioToTextResponse.data.text;
      console.log('3. Transcrição bem-sucedida:', transcribedText);
      setAudioText(transcribedText);
    } catch (error) {
      console.error('ERRO NA TRANSCRIÇÃO:');
      console.error('Status:', error.response?.status);
      console.error('Dados:', error.response?.data);
      console.error('Mensagem:', error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (audioText) {
      console.log('4. Texto transcrito recebido:', audioText);

      const fetchChatResponse = async () => {
        try {
          console.log('5. Enviando texto para Dify...');
          console.time('Chat API');

          const difyPayload = {
            inputs: {},
            query: audioText,
            user: "end-user",
            response_mode: "streaming",
            conversation_id: conversationId || null
          };

          console.log('Payload:', difyPayload);

          setLoading(true) // coloquei para o botão de startRec ficar oculto

          const chatResponse = await fetch('https://api.dify.ai/v1/chat-messages', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${process.env.REACT_APP_DIFY_API_KEY}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(difyPayload)
          });
          console.timeEnd('Chat API');

          const reader = chatResponse.body.getReader();
          let fullAnswer = '';
          let newConversationId = null;

          while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            const chunk = new TextDecoder().decode(value);
            const lines = chunk.split('\n');

            for (const line of lines) {
              if (line.trim() === '') continue;
              if (!line.startsWith('data: ')) continue;

              const data = JSON.parse(line.slice(6));
              if (data.event === 'agent_message' && data.answer) {
                fullAnswer += data.answer;
                console.log('Recebendo parte da resposta:', data.answer);
                if (data.conversation_id && !newConversationId) {
                  newConversationId = data.conversation_id;
                }
              }
            }
          }

          console.log('6. Resposta completa do Dify:', fullAnswer);
          if (newConversationId) {
            console.log('ID da conversa atualizado:', newConversationId);
            setConversationId(newConversationId);
          }

          if (!fullAnswer) {
            throw new Error('Resposta do Dify não contém texto');
          }

          setResponse(fullAnswer);
          setResponseCount(prevCount => prevCount + 1);
          setAudioUrl(null); // Resetar o audioUrl antes de atualizá-lo

          setLoading(true) // coloquei para o botão de startRec ficar oculto

          console.log('7. Enviando para ElevenLabs...');
          console.log('Texto a ser convertido:', fullAnswer);
          console.time('TTS API');

          const audioResponse = await axios.post(
            'https://api.elevenlabs.io/v1/text-to-speech/PELOilo3aUbQT42sLjVL/stream',
            //'https://api.elevenlabs.io/v1/text-to-speech/nWZa8W4FB0Uh1QpbKrdx/stream?optimize_streaming_latency=3',
            {
              text: fullAnswer,
              model_id: "eleven_flash_v2_5",
              voice_settings: {
                stability: 0.5,
                similarity_boost: 0.75
              }
            },
            {
              headers: {
                'Accept': 'audio/mpeg',
                'xi-api-key': process.env.REACT_APP_ELEVEN_LABS_API_KEY,
                'Content-Type': 'application/json'
              },
              responseType: 'arraybuffer'
            }
          );

          // Registra o tempo de início do áudio
          //setStartTime(Date.now());
          //console.log(startTime);
          console.log('8. Áudio recebido do ElevenLabs');
          console.log('Tamanho do áudio:', audioResponse.data.size, 'bytes');
          console.timeEnd('TTS API');
          const audioBlob = new Blob([audioResponse.data], { type: 'audio/mpeg' });
          const audioBlobUrl = URL.createObjectURL(audioBlob);
          setAudioUrl(audioBlobUrl);
          console.log('=== PROCESSO COMPLETO ===');

          // Registra o tempo de término do áudio
          //const endTime = Date.now();
          //console.log(endTime);
          // Calcula e exibe a duração do áudio
          //const duration = (endTime - startTime) / 1000; // Duração em segundos
          //console.log('Duração do áudio:', duration, 'segundos');

        } catch (error) {
          console.error('ERRO NO PROCESSAMENTO:');
          console.error('Status:', error.chatResponse?.status);
          console.error('Dados:', error.chatResponse?.data);
          console.error('Mensagem:', error.message);
        }
      };

      fetchChatResponse();
    }
  }, [audioText]); // Removido conversationId para evitar loops

  useEffect(() => {
    if (audioUrl && audioRef.current) {
      audioRef.current.play().then(() => {
        setIsPlaying(true);
        setLoading(false);
        const interval = setInterval(() => {
          setGifIndex((prevIndex) => (prevIndex + 1) % gifs.length);
        }, 3000); // Alterna a imagem a cada 3 segundos

        return () => clearInterval(interval);
      }).catch(error => {
        console.error('Erro ao tentar reproduzir o áudio:', error);
        setLoading(false);
      });
    }
  }, [audioUrl]);

  useEffect(() => {
    if (responseCount === 22 && !isPlaying) {
      const limitAudio = new Audio(acabou);
      limitAudio.play().catch(error => {
        console.error('Erro ao tentar reproduzir o áudio de limite atingido:', error);
      });
      setShowLimitGif(true);
    }
  }, [responseCount, isPlaying]);

  // Função para alternar entre iniciar e parar a gravação
  const toggleRecording = () => {
    setRecord((prevRecord) => !prevRecord);
    if (!record) {
      recorderControls.startRecording();
    } else {
      recorderControls.stopRecording();
    }
  };  

  return (
    <div className="app">
        <div className="recorder-container">
        <AudioRecorder 
          onRecordingComplete={handleRecordingComplete}
          recorderControls={recorderControls}
          downloadOnSavePress={false}
          downloadFileExtension="webm"
          showVisualizer={false}
        />
        </div>
        <div>
        {(responseCount < MAX_RESPONSES) && !isPlaying && !loading && ( // O botão REC só aparece até a nona interação
          <img 
            src={record ? stopImage : recordingImage}
            alt={record ? 'Parar Gravação' : 'Iniciar Gravação'}
            className="record-button"
            onClick={toggleRecording}
            style={{ cursor: 'pointer', width: '23vh', height: 'auto' }}
          />
        )}
        </div>
         <div>
      {/* Exibe o carregando enquanto a transcrição está em andamento */}
      {loading}
      {/*loading && (
        <div className="spinner-container">
          <div className="spinner">Carregando...</div>
        </div>
      )*/}

      {/* Exibe o player de áudio se houver uma URL de áudio */}
      {audioUrl && (
        <audio
          ref={audioRef}
          onCanPlay={handleAudioReady} //inseri esta linha para tentar resover problema audio no iOS
          onPlay={() => setIsPlaying(true)}
          onEnded={() => {
            setIsPlaying(false);
            if (responseCount === 21) {
              const limitReachedAudio = new Audio(acabou);
              limitReachedAudio.play().catch(error => {
                console.error('Erro ao tentar reproduzir o áudio de limite atingido:', error);
              });
              setShowLimitGif(true);
              limitReachedAudio.onended = () => {
              setShowLimitGif(false); // Desabilita gif após áudio de limite terminar
              };
            }
          }}
        >
          <source src={audioUrl} type="audio/mpeg" />
          Seu navegador não suporta o elemento de áudio.
        </audio>
      )}

      {showLimitGif && (
        <img src={gifAnimado} alt="Gif animado" className="background-gif" />
      )}
      
      {isPlaying && (
        <img src={gifs[gifIndex]} alt="Gif animado" className="background-gif" />
      )}
     </div>
    </div>
  );
};

export default ChatApp;